import { ConnectionPool } from '../core/connectionPool';
import {
  ColumnMetadata,
  Metadata,
  ServiceMetadata,
} from '../interfaces/internal';

export class MetadataContainer {
  static entityMetadataList: Metadata = {};
  static serviceMetadata: ServiceMetadata = {};
  static columns: ColumnMetadata = {};

  static pool: ConnectionPool;
}
